import { NgModule } from '@angular/core';
import { SharedModule } from '../../../../shared/shared.module';
import { PaymentsTableComponent } from './payments-table.component';
import { MatSortModule } from '@angular/material/sort';
import { MatLegacyTableModule as MatTableModule } from '@angular/material/legacy-table';
import { MatLegacyCheckboxModule as MatCheckboxModule } from '@angular/material/legacy-checkbox';
import { SinglePaymentActionsModule } from '../single-payment-actions/single-payment-actions.module';
import { MatLegacyPaginatorModule as MatPaginatorModule } from '@angular/material/legacy-paginator';
import { LegfiCurrencyPipeModule } from '../../../../../pipes/format/legfi-currency.module';
import { LegfiDatePipeModule } from '../../../../../pipes/format/legfi-date.module';
import { MatIconModule } from '@angular/material/icon';
import { MatLegacyDialogModule as MatDialogModule } from '@angular/material/legacy-dialog';
import { DepositDetailDialogModule } from 'app/components/app-layout/shared/deposit-detail-dialog/deposit-detail-dialog.module';


@NgModule({
    imports: [
        SharedModule,
        MatSortModule,
        MatTableModule,
        MatCheckboxModule,
        SinglePaymentActionsModule,
        MatPaginatorModule,
        LegfiCurrencyPipeModule,
        LegfiDatePipeModule,
        MatIconModule,
        DepositDetailDialogModule,
    ],
    declarations: [
        PaymentsTableComponent,
    ],
    exports: [
        PaymentsTableComponent,
    ],
})
export class PaymentsTableModule
{
}
